'use client';
import { resolveImageAlt } from '@eliadmin/core/src/utils/image-alt-utils';


import Image from '@eliadmin/core/src/components/image/image-wrapped';

import type { Reference } from '@eliadmin/core/src/api/references/references-types';

import { LightboxComponent } from '@eliadmin/core/src/components/lightbox/lightbox-component';
import { useDisclosure } from '@eliadmin/core/src/hooks/use-disclosure';
import { cn } from '@eliadmin/core/src/utils/style-utils';
import { useState } from 'react';

export const Gallery = ({ reference }: { reference: Reference }) => {
  const { isOpen, setIsOpen } = useDisclosure(false);
  const [imagesSorted, setImagesSorted] = useState<{ url: string; name: string }[]>([]);

  const handleOpenGallery = (images: any, index: number) => () => {
    if (Array.isArray(images) && index >= 0 && index < images.length) {
      const newImages = [...images.slice(index), ...images.slice(0, index)];
      setImagesSorted(newImages);
      setIsOpen(true);
    } else if (images && !Array.isArray(images)) {
      setImagesSorted([images]);
      setIsOpen(true);
    }
  };

  return (
    <>
      <LightboxComponent isOpen={isOpen} setIsOpen={setIsOpen} images={imagesSorted} />
      <section className={cn('custom-section')}>
        <div className={cn('custom-container', 'grid grid-cols-12 gap-6 md:gap-8 xl:gap-12')}>
          {(reference.images ?? []).map((image, index) => (
            <div
              key={image.name}
              className={cn(
                'relative aspect-video w-full overflow-hidden rounded-[20px]',
                index % 4 === 3 ? 'col-span-12' : 'col-span-12 sm:col-span-4',
              )}
              onClick={handleOpenGallery(reference.images ?? [], index)}
            >
              <Image
                src={image.url}
                alt={resolveImageAlt(image, undefined)}
                fill
                style={{ objectFit: 'cover', objectPosition: 'center' }}
                sizes="100vw"
                className="cursor-pointer"
              />
            </div>
          ))}
        </div>
      </section>
    </>
  );
};
